module.exports = __webpack_public_path__ + "img/20191126185558_6725.1005feb2.png";